import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, references } from '@apexdesigner/schema-tools';

export const position = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Name or title of the position.'),

    staffTypeId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to StaffType'),

    venueId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to Venue'),

    organizationId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to Organization'),

    staffType: references('StaffType', 'staffTypeId'),

    venue: references('Venue', 'venueId'),

    organization: references('Organization', 'organizationId'),

    placements: hasMany('Placement', 'positionId'),
  })
  .describe('A specific staffing slot at a venue within an organization.')
  .as('Position');

export { position as positionSchema };
